import React from 'react';
// این دو باید بالاتر از App ایمپورت شوند تا خطاهای زمان ارزیابیِ ماژول‌های App هم گرفته شوند.
import { Sentry } from './sentry';
import { installErrorReporter, reportError } from './services/errorReporter';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import reportWebVitals from './reportWebVitals';

// 📡 گزارشگر مرکز پایش — مستقل از Sentry و بدون DSN هم کار می‌کند.
// قبل از رندر نصب می‌شود تا خطاهای بارگذاری اولیه هم گرفته شوند.
//
// قبلاً این فراخوانی بین ایمپورت‌ها بود که `import/first` را می‌شکست و بیلد
// production را fail می‌کرد. جای جدیدش رفتار را عوض نمی‌کند: ایمپورت‌های ESM
// hoist می‌شوند، پس این خط در هر دو حالت بعد از ارزیابی همهٔ ماژول‌ها اجرا
// می‌شود — آنچه واقعاً «زودتر» بودن را تضمین می‌کند، ترتیب خودِ ایمپورت‌هاست
// که بالا حفظ شده است.
installErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode> - Removed temporarily to prevent double API calls during development
    <Sentry.ErrorBoundary
      onError={(error) => reportError(error, { level: 'fatal' })}
      fallback={
        <div style={{ padding: 40, textAlign: 'center', fontFamily: 'inherit', direction: 'rtl' }}>
          <h2>خطایی در پنل رخ داد</h2>
          <p>مشکل ثبت شد. لطفاً صفحه را دوباره بارگذاری کنید.</p>
          <button onClick={() => window.location.reload()} style={{ padding: '8px 24px', cursor: 'pointer' }}>
            بارگذاری مجدد
          </button>
        </div>
      }
    >
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  // </React.StrictMode>
);

reportWebVitals(); 